<template>
  <div class="text-input text-input--small text-input--no-label text-input--has-icon text-input--alt-background">
    <button
      v-if="modelValue"
      class="text-input__overlay-button"
      type="button"
      title="Reset Search"
      tabindex="-1"
      @click="reset"
    >
      <span class="icon fal fa-times" />
    </button>

    <input
      ref="input"
      class="text-input__input"
      type="search"
      :placeholder="placeholder"
      :value="modelValue"
      @focus="focusHandler"
      @input="inputHandler"
    >

    <div
      class="text-input__icon"
      aria-hidden="true"
    >
      <span class="icon far fa-search gray" />
    </div>
  </div>
</template>



<script>
  import debounce from 'debounce';



  export default {
    name: 'SearchInput',

    props: {
      placeholder: {
        type: String,
        default: 'Search...'
      },

      modelValue: {
        type: String,
        default: ''
      }
    },

    methods: {
      focus() {
        this.$refs.input.focus();
      },

      focusHandler() {
        window.scrollTo(0, 0);
      },

      inputHandler(event) {
        window.scrollTo(0, 0);
        this.setValue(event.target.value);
      },

      setValue: debounce(function setValue(value) {
        this.$emit('update:modelValue', value);
      }, 250),

      reset() {
        this.$refs.input.focus();
        this.$emit('update:modelValue', '');
      }
    }
  };
</script>
